// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-module__sider-icon__GW4uU {
  display: flex;
  justify-content: center;
  align-items: center;
}
.index-module__img-style__GTAX7 {
  margin-left: 20px;
  height: 60px;
  object-fit: fill;
}
/* media queries with smaller max-width have preference/overrides styles with higher max-width */
/* tablet  */
@media only screen and (min-width: 700px) and (max-width: 1280px) {
  .index-module__img-style__GTAX7 {
    height: 60px;
    width: 140px;
  }
}
/* large mobile */
@media only screen and (min-width: 600px) and (max-width: 700px) {
  .index-module__img-style__GTAX7 {
    height: 60px;
    width: 100px;
  }
}
/* small mobile */
@media only screen and (max-width: 600px) {
  .index-module__img-style__GTAX7 {
    height: 50px;
    width: 120px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/SideBar/SideBarLogo/index.module.less"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;AACA,gGAAgG;AAChG,YAAY;AACZ;EACE;IACE,YAAY;IACZ,YAAY;EACd;AACF;AACA,iBAAiB;AACjB;EACE;IACE,YAAY;IACZ,YAAY;EACd;AACF;AACA,iBAAiB;AACjB;EACE;IACE,YAAY;IACZ,YAAY;EACd;AACF","sourcesContent":[".sider-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.img-style {\n  margin-left: 20px;\n  height: 60px;\n  object-fit: fill;\n}\n/* media queries with smaller max-width have preference/overrides styles with higher max-width */\n/* tablet  */\n@media only screen and (min-width: 700px) and (max-width: 1280px) {\n  .img-style {\n    height: 60px;\n    width: 140px;\n  }\n}\n/* large mobile */\n@media only screen and (min-width: 600px) and (max-width: 700px) {\n  .img-style {\n    height: 60px;\n    width: 100px;\n  }\n}\n/* small mobile */\n@media only screen and (max-width: 600px) {\n  .img-style {\n    height: 50px;\n    width: 120px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sider-icon": `index-module__sider-icon__GW4uU`,
	"img-style": `index-module__img-style__GTAX7`
};
export default ___CSS_LOADER_EXPORT___;
